import { FC } from 'react';
import { IonButton } from '@ionic/react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';
import { Card } from '../components/Card';
import { Text } from '../components/Text';
import { HistoryViewModel } from '../support/HistoryViewModel';

export const ResourcesCard: FC = () => {
    const history = useInstance(HistoryViewModel);
    const mixpanel = useInstance(MixPanelEventEmitter);

    const onClickResources = () => {
        history.push('/resources');
        mixpanel.track('Caregiver Resources Opened');
    };

    return (
        <Card padded>
            <div style={{marginBottom: 12}}>
                <Text><b>Caregiver Resources</b></Text>
            </div>

            <p>
                <Text type="detail">Find Innerhive-curated resources: Community Support Groups, Services, and much more!</Text>
            </p>

            <div style={{margin: '20px auto', maxWidth: 300, textAlign: 'center'}}>
                <IonButton
                    expand="block"
                    onClick={onClickResources}
                >
                    Find Resources
                </IonButton>
            </div>
        </Card>
    );
};
